import React, { useId, useState } from "react";

import EcoIcon from "../eco-icon/EcoIcon";

type EcoFiltersCardProps = {
  /** Resumo mostrado no botão recolhido do celular (ex.: "6 meses · Todas as lojas"). */
  summary: string;
  /** Filtros fora do padrão — vira o "(2)" do botão. */
  activeCount?: number;
  children: React.ReactNode;
};

/**
 * Cartão de filtros. No desktop fica sempre aberto; no celular (≤720px) vira um
 * botão "Filtros (n)" com resumo, que abre e fecha o conteúdo.
 */
const EcoFiltersCard: React.FC<EcoFiltersCardProps> = ({ summary, activeCount = 0, children }) => {
  const [open, setOpen] = useState(false);
  const bodyId = useId();

  return (
    <section className={`ecoCard ecoFilters${open ? " is-open" : ""}`} aria-label="Filtros">
      <button
        type="button"
        className="ecoFilters__toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={bodyId}
      >
        <span>Filtros{activeCount ? ` (${activeCount})` : ""}</span>
        <span className="ecoFilters__summary">{summary}</span>
        <EcoIcon name={open ? "arrowUp" : "arrowDown"} size={16} />
      </button>

      <div id={bodyId} className="ecoFilters__body">
        {children}
      </div>
    </section>
  );
};

export default EcoFiltersCard;
